function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-120 -5608)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 5346)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(120 170)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 92)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m23.315 16.959-5.25-2.25c-0.4605-0.1965-0.996-0.0645-1.3125 0.324l-2.325 2.8395c-3.6495-1.7205-6.585-4.656-8.3055-8.3055l2.841-2.325c0.387-0.315 0.5205-0.852 0.3225-1.3125l-2.25-5.25c-0.2175-0.4995-0.759-0.7725-1.2885-0.651l-4.875 1.125c-0.5115 0.1185-0.8715 0.5715-0.8715 1.0965 0 12.022 9.744 21.75 21.75 21.75 0.5235 0 0.978-0.3615 1.0965-0.8715l1.125-4.8765c0.12-0.5325-0.156-1.0755-0.657-1.293"
}))))));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.def13115.svg";
export { ForwardRef as ReactComponent };